import { add, addDays, formatISO, set, startOfWeek, sub } from 'date-fns';
export const ISOTimestampRegEx = /^\d{8}T\d{6}Z$/;
export function newISOTimestamp(d) {
    return formatISO(d || Date.now().valueOf(), { format: 'basic' });
}
export const ISODateRegEx = /^\d{4}-\d{2}-\d{2}$/;
export function newISODate(d) {
    return formatISO(d || Date.now().valueOf(), { representation: 'date' });
}
export function ceilDate(d = new Date(), interval) {
    switch (interval) {
        case 'minute':
            d = set(d, { minutes: d.getMinutes() + 1, seconds: 0, milliseconds: 0 });
            break;
        case '5 minutes':
            d = set(d, { minutes: (Math.floor((d.getMinutes() / 5)) * 5) + 5, seconds: 0, milliseconds: 0 });
            break;
        case '15 minutes':
            d = set(d, { minutes: (Math.floor((d.getMinutes() / 15)) * 15) + 15, seconds: 0, milliseconds: 0 });
            break;
        case 'hour':
            d = set(d, { hours: d.getHours() + 1, minutes: 0, seconds: 0, milliseconds: 0 });
            break;
        case 'day':
            d = set(d, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
            d = addDays(d, 1);
            break;
        case 'week':
            d = startOfWeek(d);
            d = addDays(d, 7);
            break;
    }
    return d;
}
export function floorDate(d = new Date(), interval) {
    switch (interval) {
        case 'minute':
            d = set(d, { minutes: d.getMinutes(), seconds: 0, milliseconds: 0 });
            break;
        case '5 minutes':
            d = set(d, { minutes: (Math.floor((d.getMinutes() / 5)) * 5), seconds: 0, milliseconds: 0 });
            break;
        case '15 minutes':
            d = set(d, { minutes: (Math.floor((d.getMinutes() / 15)) * 15), seconds: 0, milliseconds: 0 });
            break;
        case 'hour':
            d = set(d, { hours: d.getHours(), minutes: 0, seconds: 0, milliseconds: 0 });
            break;
        case 'day':
            d = set(d, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
            break;
        case 'week':
            d = startOfWeek(d);
            break;
    }
    return d;
}
export function offsetCeilDate(d = new Date(), offsetTemplate, interval) {
    const offsetDuration = {
        days: offsetTemplate.getDay(),
        hours: offsetTemplate.getHours(),
        minutes: offsetTemplate.getMinutes(),
        seconds: offsetTemplate.getSeconds()
    };
    // get an offset ceil by subtracting the offset, ceiling, then adding the offset back.
    d = sub(d, offsetDuration);
    d = ceilDate(d, interval);
    d = add(d, offsetDuration);
    return d;
}
export function isBetweenLocalHours(d, startHour, endHour, tzOffsetMinutes) {
    let mins = (d.getHours() * 60) + d.getMinutes(); // start at UTC
    mins = (mins - tzOffsetMinutes) % (24 * 60); // handle overruns
    mins = mins < 0 ? mins + (24 * 60) : mins; // handle underruns
    return mins >= (startHour * 60) && mins < (endHour * 60);
}
//# sourceMappingURL=dates.js.map